import { Field } from 'components/Field'
import { FormFieldProps } from 'components/FormFields'
import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'

export const selectFieldStyles = css`
	select {
		background: ${props => props.theme.colors.white.val};
	}
`

const SelectFieldView = styled.div`
	${selectFieldStyles}
`
export type SelectOption = {
	val: string | number
	txt?: ReactNode
}

export type SelectFieldProps = FormFieldProps & {
	options: SelectOption[]
	defaultTxt?: string | boolean
	placeholder?: string
	onSelect: (val: string) => void
	value: string
}
export const SelectField = ({
	options,
	defaultTxt,
	placeholder,
	className,
	name,
	onSelect,
	value,
	...fieldProps
}: SelectFieldProps): JSX.Element => {
	const selectOptions = defaultTxt
		? [
				{
					val: '',
					txt: typeof defaultTxt === 'boolean' ? 'Select' : defaultTxt,
				},
				...options,
		  ]
		: options

	return (
		<SelectFieldView className={`select-field${className ? ` ${className}` : ''}`}>
			<Field {...fieldProps} name={name}>
				<select name={name} onChange={e => onSelect(e.currentTarget.value)} value={value}>
					{selectOptions?.length
						? selectOptions.map(({ val, txt }) => (
								<option disabled={val === ''} key={val} value={val}>
									{txt || val}
								</option>
						  ))
						: null}
				</select>
			</Field>
		</SelectFieldView>
	)
}
